import { render, staticRenderFns } from "./MareLiberumMenu.vue?vue&type=template&id=5923f374&scoped=true"
import script from "./MareLiberumMenu.vue?vue&type=script&lang=js"
export * from "./MareLiberumMenu.vue?vue&type=script&lang=js"
import style0 from "./MareLiberumMenu.vue?vue&type=style&index=0&id=5923f374&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5923f374",
  null
  
)

export default component.exports